import ReactEcharts from "echarts-for-react";
import {useEffect, useState} from "react";
import {getReportChart} from "../../../../api/report";
import moment from "moment/moment";
import {KeyConstant} from "../constant/keyConstant";
import {mapTag} from "../common/mapTag";
import {convertTooltip, getCurrencyUnit, getRateCurrency} from "../common/renderUnit";
import {useSelector} from "react-redux";
import {useSearchParams} from "react-router-dom";
const format = "DD/MM/YYYY"
const formatLocalDateTime = "YYYY-MM-DDTHH:mm:ss"
const formatCompare = "YYYYMMDD"
const Report = ({type, code, reloadReport, refresh}) => {

    const [searchParams] = useSearchParams()
    const {reloadData} = useSelector(state => state.layoutInteractionReducer)
    const [xAxis, setXAxis] = useState()
    const [jump, setJump] = useState()
    const [compare, setCompare] = useState()
    const [endDateCompare, setEndDateCompare] = useState()
    const [currentPeriod, setCurrentPeriod] = useState()
    const [samePeriod, setSamePeriod] = useState()
    const [currencyUnit, setCurrencyUnit] = useState("");
    const [rateCurrenCy, setRateCurrenCy] = useState(1);
    const [dataLegend, setDataLegend] = useState([]);
    const [width, setWidth] = useState(window.innerWidth);

    function handleWindowSizeChange() {
        setWidth(window.innerWidth);
    }

    useEffect(() => {
        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        }
    }, []);

    const isMobile = width <= 768;

    useEffect(() => {

        let dateStart = searchParams.get("startDate") ? moment(searchParams.get("startDate")).toDate() :
            moment().subtract(28, "days").toDate()
        let dateEnd = searchParams.get("endDate") ? moment(searchParams.get("endDate")).toDate() :
            moment().subtract(1, "days").toDate()

        let startDate = moment(dateStart);
        let endDate = moment(dateEnd);
        let startDateAxios = moment(dateStart);
        let endDateAxios = moment(dateEnd);
        let startDateCompare = null
        let endDateCompare = null

        let compare = searchParams.get("compare") ? searchParams.get("compare") : false
        let compareType = searchParams.get("compareType") ? searchParams.get("compareType") : "previousPeriod"
        let typeCheck = searchParams.get("type") ? searchParams.get("type") : KeyConstant.THIRTY_DAYS_AGO
        if (compare) {
            let dateDiff = endDate.diff(startDate, 'days') + 1
            if (compareType === "previousPeriod") {
                switch (typeCheck) {
                    case KeyConstant.TODAY:
                    case KeyConstant.YESTERDAY:
                        startDateCompare = startDate.subtract(1, "days").format(formatLocalDateTime)
                        endDateCompare = endDate.subtract(1, "days").format(formatLocalDateTime)
                        break;
                    case KeyConstant.THIS_WEEK:
                    case KeyConstant.LAST_WEEK:
                        startDateCompare = startDate.subtract(1, "weeks").startOf("week").format(formatLocalDateTime)
                        endDateCompare = endDate.subtract(1, "weeks").endOf("week").format(formatLocalDateTime)
                        break;
                    case KeyConstant.THIS_MONTH:
                    case KeyConstant.LAST_MONTH:
                        startDateCompare = moment(startDate).subtract(1, "months").startOf("month").format(formatLocalDateTime)
                        endDateCompare = moment(startDate).subtract(1, "months").endOf("month").format(formatLocalDateTime)
                        break;
                    case KeyConstant.SEVEN_DAYS_AGO:
                        startDateCompare = startDate.subtract(7, "days").format(formatLocalDateTime)
                        endDateCompare = endDate.subtract(7, "days").format(formatLocalDateTime)
                        break;
                    case KeyConstant.THIRTY_DAYS_AGO:
                        startDateCompare = startDate.subtract(30, "days").format(formatLocalDateTime)
                        endDateCompare = endDate.subtract(30, "days").format(formatLocalDateTime)
                        break;
                    case KeyConstant.NINETY_DAYS_AGO:
                        startDateCompare = startDate.subtract(90, "days").format(formatLocalDateTime)
                        endDateCompare = endDate.subtract(90, "days").format(formatLocalDateTime)
                        break;
                    default :
                        startDateCompare = startDate.subtract(dateDiff, "days").format(formatLocalDateTime)
                        endDateCompare = endDate.subtract(dateDiff, "days").format(formatLocalDateTime)
                        break;
                }
            } else if (compareType === "periodLastYear") {
                startDateCompare = startDate.subtract(1, "years").format(formatLocalDateTime)
                endDateCompare = endDate.subtract(1, "years").format(formatLocalDateTime)
            }
        }
        getReportChart(code, type, startDateAxios.format(formatLocalDateTime),
            endDateAxios.format(formatLocalDateTime), startDateCompare, endDateCompare).then(r => {
            setJump(r.jump)
            setCompare(r.compare)
            setEndDateCompare(r.endDateCompare)
            setXAxis(r?.nameXAxis)
            setCurrencyUnit(getCurrencyUnit(type, r.currentPeriod, r.samePeriod))
            const rate = getRateCurrency(type, r.currentPeriod, r.samePeriod)
            setRateCurrenCy(rate)
            let mapCurrent = r.currentPeriod?.map(item => item / rate)
            setCurrentPeriod(mapCurrent)
            let mapSame = r.samePeriod
            if (r.samePeriod) {
                mapSame = r.samePeriod?.map(item => item / rate)
            }
            setSamePeriod(mapSame)
        })
            .catch(() => {
            })

        if (compare) {
            setDataLegend([mapTag(type, dateStart, endDate), mapCalendarType()])
        } else {
            setDataLegend([mapTag(type, dateStart, dateEnd)])
        }
    }, [reloadReport, type, reloadData, refresh, code, searchParams])

    const mapCalendarType = () => {
        let compareType = searchParams.get("compareType") ? searchParams.get("compareType") : "previousPeriod"
        if (compareType === "previousPeriod") {
            return "Kỳ trước"
        } else if (compareType === "periodLastYear") {
            return "Cùng kỳ năm trước"
        } else {
            return ""
        }
    }

    const getOption = {
        tooltip: {
            valueFormatter: (value) => `${convertTooltip(type, value * rateCurrenCy)}`,
            trigger: 'axis'
        },
        legend: {
            data: dataLegend
        },
        grid: {
            left: '3%',
            right: '4%',
            bottom: '0%',
            containLabel: true
        },
        xAxis: {
            type: 'category',
            boundaryGap: false,
            show: xAxis,
            data: xAxis,
            splitNumber: 6,
            axisPointer: {
                label: {
                    formatter: function (params) {
                        let dateEnd = searchParams.get("endDate") ? moment(searchParams.get("endDate")).toDate() :
                            moment().subtract(1, "days").toDate()
                        if (endDateCompare) {
                            if (jump === 1) {
                                return (
                                    params.value + " vs " +
                                    moment(params.value, format).subtract(compare, "days").format(format)
                                );
                            } else {
                                if (moment(params.value, format).add(jump - 1, "days").format(formatCompare) >
                                    moment(dateEnd).format(formatCompare)) {
                                    return (
                                        params.value
                                    );
                                } else {
                                    return (
                                        params.value + " - " +
                                        moment(params.value, format).add(jump - 1, "days").format(format)
                                        + " vs " +
                                        moment(params.value, format).subtract(compare, "days").format(format) + " - "
                                        + moment(params.value, format).add(jump - 1, "days").subtract(compare, "days").format(format)
                                    );
                                }
                            }
                        } else {
                            if (jump === 1) {
                                return params.value
                            } else {
                                if (moment(params.value, format).add(jump - 1, "days").format(formatCompare) >
                                    moment(dateEnd).format(formatCompare)) {
                                    return params.value
                                } else {
                                    return ( params.value + " - " +
                                        moment(params.value, format).add(jump - 1, "days").format(format)
                                    );
                                }
                            }
                        }
                    }
                }
            },
        },
        yAxis: {
            type: 'value',
            show: true,
            name: currencyUnit,
            nameTextStyle: {
                padding: [0, 30, 0, 0]
            }
        },
        series: [{
            name: mapTag(searchParams.get("type") ? searchParams.get("type") : KeyConstant.THIRTY_DAYS_AGO,
                searchParams.get("startDate") ? moment(searchParams.get("startDate")).toDate() :
                    moment().subtract(28, "days").toDate(),
                searchParams.get("endDate") ? moment(searchParams.get("endDate")).toDate() :
                    moment().subtract(1, "days").toDate()),
            type: 'line',
            showSymbol: currentPeriod?.length === 1,
            data: currentPeriod,
            color: "#0065D9",
            smooth: true,
        },
            {
                name: mapCalendarType(),
                type: 'line',
                showSymbol: samePeriod?.length === 1,
                data: samePeriod,
                color: "#A3DDFF", smooth: true,
            }]

    };
    return <ReactEcharts
        option={getOption}
        style={{
            height: isMobile ? "220px" : "95%",
            paddingBottom: 10,
        }}
        className={"customer_report"}
    />
}

export default Report
